//create a function that replaces all __typename keys in an object nested to any depth
//recursively replace __typename keys

const whiteListed = [
  'Image',
  'HeaderSection',
  'HeaderLink',
  'File',
  'UmbracoMediaVideo',
  'UmbracoMediaVectorGraphics',
  'MediaWithCrops',
  'Page',
  'HeaderLinkV2',
  'HeaderDropdown',
  'HeaderV2ItemSettings',
  'NavigationSubMenuGroup',
  'HeaderDropdownContentElement',
  'ProductView',
  'M64Accordions',
]
export const replaceTypename = (obj: any, skip?: boolean) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => replaceTypename(item, skip))
  }
  const newObj = {}
  for (const key in obj) {
    if (key === '__typename' && !whiteListed.includes(obj[key]) && !skip) {
      continue
    }
    newObj[key] = replaceTypename(obj[key], key == 'components')
  }
  return newObj
}
